import React, { useEffect, useMemo } from 'react';

import { CommandsManager, HotkeysManager, ServicesManager } from '@core';
import getWindowLevelPresets from '@core/defaults/windowLevelPresets';
import { useGetDisplaysetModality } from '@hooks';
import { useAppConfig } from '@state';
import { CustomPresets, ListMenu, WindowLevelMenuItem } from '@ui';
import { createWwwcPreset } from '@utils';

/**
 * Danh sách WL Preset hiển thị ở left panel
 */
export const PanelWLPreset = ({
	commandsManager,
	servicesManager,
	hotkeysManager,
}: {
	hotkeysManager?: HotkeysManager;
	servicesManager: ServicesManager;
	commandsManager: CommandsManager;
}) => {
	const modality = useGetDisplaysetModality(servicesManager);
	const [appConfig] = useAppConfig();
	const presets = getWindowLevelPresets(modality, appConfig);

	/**
	 *Effect này update lại hotkeys theo danh sách preset ứng với từng loại máy
	 */
	useEffect(() => {
		if (presets && hotkeysManager) {
			const presetHotKeys = Object.keys(presets).map((presetKey) => {
				const preset = presets[presetKey];
				return {
					commandName: 'setWindowLevel',
					commandOptions: {
						window: parseInt(preset.window),
						level: parseInt(preset.level),
						type: 'NORMAL',
					},
					isEditable: false,
					keys: [(parseInt(presetKey) + 1).toString()],
				};
			});
			presetHotKeys.unshift({
				commandName: 'setWindowLevel',
				commandOptions: {
					type: 'PSEUDO',
					window: 0,
					level: 0,
				},
				isEditable: false,
				keys: ['1'],
			});
			hotkeysManager.updateHotKeys(presetHotKeys);
		}
	}, [hotkeysManager, presets]);

	const items = useMemo(() => {
		const listItems = Object.values(presets || {}).map((item) => {
			return createWwwcPreset({ preset: item, type: 'NORMAL' });
		});
		listItems.unshift(createWwwcPreset({ type: 'PSEUDO', preset: { description: 'Pseudo Color', level: '', window: '' } }));
		return listItems;
	}, [presets]);

	const onClick = ({ item }) => {
		commandsManager.run(item.commands);
	};

	return (
		<div className="saola-scrollbar invisible-scrollbar overflow-auto text-common-gray">
			<ListMenu
				items={items}
				renderer={WindowLevelMenuItem}
				className={'rounded-none border-none'}
				onClick={onClick}
				activeOptions={false}
			/>
			<div className="mx-3 border-t border-common-dark"></div>
			<CustomPresets modality={modality} />
		</div>
	);
};